import { render } from "./OpenVpnSettings.vue?vue&type=template&id=52cc4f7f"
import script from "./OpenVpnSettings.vue?vue&type=script&lang=js"
export * from "./OpenVpnSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__